export default __webpack_public_path__ + "6fb503e6438ed54371fe5037e5b92d6b.gif";